<dbw-investor-viewer-accordion
  anchorId="investor-viewer-passifs"
  accordionTitle="Passifs"
  [itemsCount]="liabilities().length">
  @if (liabilities().length === 0) {
    <div class="empty-state">Aucun passif disponible.</div>
  } @else {
    <div class="section-stack">
      @for (liability of liabilities(); track liability.liabilityId) {
        <article class="sub-card dbw-card dbw-card--md">
          <header class="entity-header">
            <div>
              <h5>{{ formatText(liability.designation) }}</h5>
              <p>
                Passif #{{ liability.liabilityId }} • Nature
                {{ formatText(liability.natureCode) }} • ArianeId
                {{ formatText(liability.arianeId) }}
              </p>
            </div>
            <div class="tag-cluster">
              <strong class="entity-value">{{
                formatCurrency(liability.amount)
              }}</strong>
            </div>
          </header>

          <div class="detail-grid">
            <article class="detail-item dbw-card dbw-card--lg">
              <span class="detail-item__label">Détention</span>
              <strong>{{ formatText(liability.ownershipCode) }}</strong>
            </article>
            <article class="detail-item dbw-card dbw-card--lg">
              <span class="detail-item__label">Type de crédit</span>
              <strong>{{ formatText(liability.creditTypeCode) }}</strong>
            </article>
            <article class="detail-item dbw-card dbw-card--lg">
              <span class="detail-item__label">Souscription</span>
              <strong>{{ formatDate(liability.subscriptionDate) }}</strong>
            </article>
            <article class="detail-item dbw-card dbw-card--lg">
              <span class="detail-item__label">Durée</span>
              <strong>{{ formatNumber(liability.duration) }}</strong>
            </article>
            <article class="detail-item dbw-card dbw-card--lg">
              <span class="detail-item__label">Durée restante</span>
              <strong>{{ formatNumber(liability.remainingDuration) }}</strong>
            </article>
            <article class="detail-item dbw-card dbw-card--lg">
              <span class="detail-item__label">Taux ADI</span>
              <strong>{{ formatPercentage(liability.adiRate) }}</strong>
            </article>
            <article class="detail-item dbw-card dbw-card--lg">
              <span class="detail-item__label">Mensualité ADI</span>
              <strong>{{ formatCurrency(liability.adiMonthlyPayment) }}</strong>
            </article>
            <article class="detail-item dbw-card dbw-card--lg">
              <span class="detail-item__label">Capital restant dû</span>
              <strong>{{
                formatCurrency(liability.remainingCapitalDue)
              }}</strong>
            </article>
            <article class="detail-item dbw-card dbw-card--lg">
              <span class="detail-item__label">Actif lié</span>
              <strong>{{
                liability.linkedAssetId ? "Actif #" + liability.linkedAssetId : "-"
              }}</strong>
            </article>
          </div>

          @if (liability.notes?.trim()) {
            <div class="note-banner dbw-card dbw-card--md">
              <span class="identity-item__label">Note</span>
              <strong>{{ liability.notes }}</strong>
            </div>
          }

          <div class="mini-block">
            <div class="subheading subheading--small"><h5>Détenteurs</h5></div>
            @if (liability.holders.length === 0) {
              <div class="empty-inline">Aucun détenteur.</div>
            } @else {
              <div class="mini-card-list">
                @for (holder of liability.holders; track $index) {
                  <article class="mini-card dbw-card dbw-card--lg">
                    <strong>{{ formatHolderLabel(holder.investorId) }}</strong>
                    <span>{{ formatLiabilityHolderShares(holder) }}</span>
                  </article>
                }
              </div>
            }
          </div>

          @if (parseAdditionalFields(liability.additionalFieldsJson).length > 0) {
            <div class="mini-block">
              <div class="subheading subheading--small">
                <h5>Champs complémentaires</h5>
              </div>
              <div class="mini-card-list">
                @for (
                  field of parseAdditionalFields(liability.additionalFieldsJson);
                  track $index
                ) {
                  <article class="mini-card dbw-card dbw-card--lg">
                    <span class="detail-item__label">{{ field.label }}</span>
                    <strong>{{ field.value }}</strong>
                  </article>
                }
              </div>
            </div>
          }
        </article>
      }
    </div>
  }
</dbw-investor-viewer-accordion>
